export default __webpack_public_path__ + "static/media/f084e424e57f2eb72fd0cf8a0eafafc4.svg";